import React from 'react';
import * as Styled from './styled';
import { ReportResult, InProgressStatus } from '../../../models';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import Link from 'next/link';

interface ReportNameCellProps {
  cell: TableCell;
}

function ReportNameCell({ cell }: ReportNameCellProps): JSX.Element {
  const rowData = cell.row.original as ReportResult;
  return rowData.statusId === InProgressStatus.taskComplete ? (
    <Link href="/results/[id]" as={`/results/${rowData.taskId}`} passHref legacyBehavior>
      <Styled.ReportNameCell>{rowData.taskName}</Styled.ReportNameCell>
    </Link>
  ) : (
    <Styled.ReportNameCell>{rowData.taskName}</Styled.ReportNameCell>
  );
}

export default ReportNameCell;
